import type { ReactNode } from 'react';

interface StatBoxProps {
  label: string;
  value: ReactNode;
  sub?: ReactNode;
  delta?: ReactNode;
  display?: boolean;  // use serif display size
}

export function StatBox({ label, value, sub, delta, display }: StatBoxProps): ReactNode {
  return (
    <div className="stat">
      <div className="label">{label}</div>
      <div className={`value${display ? ' is-display' : ''}`}>{value}</div>
      {sub ? <div className="sub">{sub}</div> : null}
      {delta ? <div>{delta}</div> : null}
    </div>
  );
}
